"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var shallowEquals = require("shallow-equal/objects");
function areDepsEqual(prev, current, isDepEqual) {
    var currentLength = current.length;
    if (prev.length !== currentLength) {
        return false;
    }
    for (var i = 0; i < currentLength; i += 1) {
        if (!isDepEqual(prev[i], current[i])) {
            return false;
        }
    }
    return true;
}
function useSpecificMemo(factory, deps, isDepEqual) {
    var value = react_1.useRef(null);
    var previousDeps = react_1.useRef(deps);
    if (value.current === null) {
        value.current = factory();
    }
    if (!areDepsEqual(previousDeps.current, deps, isDepEqual)) {
        previousDeps.current = deps;
        value.current = factory();
    }
    return value.current;
}
exports.useSpecificMemo = useSpecificMemo;
function useShallowEqualsMemo(factory, deps) {
    return useSpecificMemo(factory, deps, shallowEquals);
}
exports.useShallowEqualsMemo = useShallowEqualsMemo;
function useUnmount(factory) {
    react_1.useEffect(function () {
        return factory;
    }, []);
}
exports.useUnmount = useUnmount;
